import styled from "styled-components"

export const Title = styled.p`
margin: 0;
text-align: center;
font-size: 2.5rem;
font-weight: bold;
/* margin-top: 4rem; */
`

export const FieldsContainer = styled.div`
  display: flex;
  justify-content:flex-end;
  align-items: center;
  column-gap: 1rem;
  margin-bottom: 2rem;
`;

export const CardContainer = styled.div`
display: flex;
flex-direction: column;
row-gap: 2rem;
align-items:center;
padding:0rem 1rem;
`

export const CardsMain = styled.div`
  width: 100%;
  justify-content: flex-start;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  justify-content: center;
  gap: 2rem;
  padding-bottom: 30px;
  margin-bottom: -20px;
  padding-left: 1rem;
  padding-right: 1rem;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  border-radius: 12px;
  border: ${({ active }) => (active ? "2px solid #2a3da3" : "none")};
  cursor: pointer;
  width: 100%;
  height: auto;
  background: white;
  transition: transform 0.2s ease-in-out;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

export const CardsHead = styled.div``;

export const CardImg = styled.div`
  display: flex;
  align-items: center;
`;

export const CardDetails = styled.div`
  width: 100%;
  display: flex;
  margin: 10px;
  @media (max-width: 1250px) {
    flex-direction: column;
  }
`;

export const CardDetailsColumn = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
`;

export const CardItemsLarge = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: warp;
`;

export const CardItemsSmall = styled.div`
  display: flex;
  margin-top: auto;
  flex-wrap: warp;
`;

export const Img = styled.img`
  width: 100%;
  object-fit: contain;
  max-height: 214px;

  @media (max-width: 2630px) {
    max-height: 214px;
    max-width: 100%;
  }
`;

export const PropertyCardDetails = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0rem 0.5rem 0 1rem;
`;

export const PropertyCardH3 = styled.h3`
  font-size: 1.4vw;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 1300px) {
    font-size: 1.27rem;
  }
`;

export const Desc = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1rem;
  padding: 0.5rem 0 0.5rem 1rem;
  @media (max-width: 2630px) {
    line-height: 1rem;
  }
`;

export const Counts1 = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 22rem;
  border-radius: 1rem;
  background-color: white;

  @media (max-width: 2630px) {
    width: 22rem;
  }
`;

// New styled components matching Asset-Listing.js structure
export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  margin-top: 1rem;
`;

export const CardTitle = styled.h2`
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardIcons = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const CardValueSection = styled.div`
  text-align: center;
  margin: 1rem 0;
`;

export const CardValue = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
  color: #000;
`;

export const CardLabel = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin: 0;
`;

export const StatsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  border-top: 1px solid #f0f0f0;
  background-color: #fff;
  border-radius:12px;
`;

export const StatBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  padding-inline: 2px;
  border-right: ${props => props.last ? 'none' : '1px solid #f0f0f0'};
`;

export const StatLabel = styled.span`
  font-size: 0.8rem;
  color: #666;
  margin-top: 0.5rem;
`;

export const StatValue = styled.span`
  font-size: 1rem;
  font-weight: 500;
  color: ${props => props.color || '#000'};
  margin-top: 0.2rem;
`;
